import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Output } from '@angular/core';

export type LeftRightButtonPairMode = 'left' | 'right' | 'both';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-left-right-button-pair',
  templateUrl: './left-right-button-pair.component.html',
})
export class LeftRightButtonPairComponent {
  public readonly mode = input.required<LeftRightButtonPairMode>();

  @Output() public readonly leftPressed = new EventEmitter<void>();
  @Output() public readonly rightPressed = new EventEmitter<void>();

  onLeftPressed(): void {
    this.leftPressed.emit();
  }

  onRightPressed(): void {
    this.rightPressed.emit();
  }
}
